export default __webpack_public_path__ + "static/media/rishabh.0424e9de.jpg";